import { useNavigate } from "react-router-dom";
import "../styles/Landing.css"
import spineCommonsLogo from "../assets/spine commons image logo.png";

export default function LandingNav() {
  const nav = useNavigate();

  return (
    <div className="landingNav">
      <div
        className="landingLogo"
        onClick={() => nav('/')}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            nav("/");
          }
        }}
        aria-label="Go to home"
      >
        <div className="landingLogoLockup" aria-hidden="true">
          <img className="landingLogoMark" src={spineCommonsLogo} alt="Spine Commons" />
          <span className="landingLogoText">Spine Commons</span>
        </div>
      </div>
      <div className="landingButtons">
        <button className="navBtn" onClick={() => nav('/how-it-works')}>What is it?</button>
        <button className="navBtn primary" onClick={() => nav('/auth')}>Sign in</button>
      </div>
    </div>
  );
}